import React from "react";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import { useResponsiveFontSize } from "../functions";

const ButtonBar = ({
  buttons,
  width = "100%",
  // fontSize,
  gap,
  background = `linear-gradient(
            to right bottom,
            rgba(248, 248, 255, 0.2),
            rgba(248, 248, 255, 0.05)
            )`,
  hoveredBackground = `linear-gradient(
                to right bottom,
                rgba(55, 166, 222, 0.75),
                rgba(55, 166, 222, 0.375)
                )`,
}) => {
  const fontSize = useResponsiveFontSize();
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${buttons.length}, 1fr)`,
        placeItems: "center",
        gap: gap,
      }}
    >
      {buttons.map((item, index) => (
        <Box
          key={index}
          component={Link}
          to={item.path}
          sx={{
            width: { width },
            background: background,
            backdropFilter: "blur(1rem)",
            borderRadius: "0.25rem",
            color: "white",
            textDecoration: "none",
            "&:hover": {
              background: hoveredBackground,
              boxShadow: "0px 0px 20px rgba(55, 166, 222, 0.8)",
              filter: "brightness(1.2)",
            },
            marginTop: "2rem",
            paddingTop: "1rem",
            paddingBottom: "1rem",
            display: "grid",
            placeItems: "center",
            fontWeight: "100",
            fontSize: fontSize,
          }}
        >
          {item.label}
        </Box>
      ))}
    </Box>
  );
};

export default ButtonBar;
